import React, { useRef } from "react";
import Lottie from "lottie-web";

const LottieControl = ({ animationData, config = {}, ...props }) => {
  const isInited = useRef(false);
  return (
    <div
      ref={dom => {
        if (dom && !isInited.current) {
          Lottie.loadAnimation({
            container: dom, // the dom element that will contain the animation
            renderer: "canvas",
            rendererSettings: {
              ...config.rendererSettings
            },
            loop: true,
            autoplay: true,
            ...config,
            animationData
          });
          isInited.current = true;
        }
      }}
      {...props}
    />
  );
};

export default LottieControl;
